/**
 * Packer Production Chart Component
 * Displays production volume assigned to each packer
 */

import { Card, Empty } from 'antd';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import type { PackerProductionData } from '../../services/api/productionDashboardService';

interface PackerProductionChartProps {
  data: PackerProductionData[];
}

const COLORS = ['#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1', '#13c2c2', '#eb2f96', '#fa8c16'];

export const PackerProductionChart: React.FC<PackerProductionChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Card title="Producción por Etiquetador">
        <Empty description="No hay datos disponibles" />
      </Card>
    );
  }

  const chartData = data.map(item => ({
    name: item.packer_name,
    production: item.total_production_kg / 1000, // Convert to tons
  }));

  return (
    <Card title="Producción por Etiquetador">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" label={{ value: 'Toneladas', position: 'insideBottom', offset: -5 }} />
          <YAxis type="category" dataKey="name" width={90} />
          <Tooltip
            formatter={(value: number) => [`${value.toFixed(2)} t`, 'Producción']}
          />
          <Bar dataKey="production" fill="#1890ff">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
